/**
 * Foutregistratie in de browser.
 *
 * De DSN komt van /api/config en niet uit een `VITE_`-variabele. Een Vite-variabele wordt bij
 * het bouwen ingebakken, en de frontend wordt op de server gebouwd door het deploy-script; dan
 * zou de DSN daar ook nog doorgegeven moeten worden. Nu staat alle configuratie op één plek.
 *
 * Sentry wordt pas ingeladen wanneer er een DSN is. Zonder DSN haalt de browser de bibliotheek
 * dus helemaal niet op — dat scheelt ruim honderd kilobyte voor wie hem niet gebruikt.
 */

let gestart = false;

export async function startSentry(dsn: string | null, environment: string): Promise<void> {
  if (!dsn || gestart) return;
  gestart = true;

  const Sentry = await import('@sentry/react');

  Sentry.init({
    dsn,
    environment,
    sendDefaultPii: false,
    // Alleen fouten. Sessieopnames en prestatiemetingen zouden schermafdrukken van
    // prijsgegevens en e-mailadressen naar buiten sturen; dat is hier niet nodig.
    tracesSampleRate: 0,

    beforeSend(event) {
      // Een productpagina van een concurrent kan in een URL of melding staan; de eigen
      // feed-URL met token nooit — die verlaat de server niet. Toch dezelfde voorzichtigheid.
      for (const exception of event.exception?.values ?? []) {
        if (exception.value) exception.value = maskeerToken(exception.value);
      }
      if (event.request?.url) event.request.url = maskeerToken(event.request.url);
      return event;
    },
  });
}

/** Zelfde patroon als de redactie aan de serverkant, maar dan zonder Node-afhankelijkheden. */
function maskeerToken(text: string): string {
  return text.replace(
    /([?&](?:token|api[-_]?key|key|secret|password|auth|access[-_]?token|sig)=)[^&\s"']+/gi,
    '$1••••',
  );
}
